import React, { useMemo, useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useListForHomeQuery } from "../../../api/collection.api";
import LoadingComponent from "../../../common/Loading/Loading.component";
import SectionHeading from "../../../common/SectionHeading/SectionHeading";
import "./Collection.css";



const Collection = ({ limit = 4, isAll = false, showHeading = true }) => {
  const { data, isLoading } = useListForHomeQuery(undefined, {
    refetchOnMountOrArgChange: false,
    skip: false,
  });

  const collection = useMemo(() => {
    const list = data?.result || [];
    if (isAll || limit === null) {
      return list;
    }
    return list.slice(0, limit);
  }, [data, limit, isAll]);

  if (isLoading && !data) {
    return (
      <LoadingComponent
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "40vh",
          backgroundColor: "#FAF8F5",
        }}
      />
    );
  }

  if (!collection || collection.length === 0) {
    return null;
  }

  return (
    <section aria-label="The Collections">
      {/* EDITORIAL HEADER */}
      {showHeading && (
        <SectionHeading
          tag="h2"
          title="The Collections"
          subtitle="A study in form, movement and modern craft. Designed with restraint, made to remain."
        />
      )}
      <div className="collecton_grid">
        {collection.map((item, index) => {
          const itemUrl = `/collection/${item.slug || "view"}/${item._id}`;
          return (
            <div key={item._id || `collection-${index}`}>
              <Link
                to={itemUrl}
                className="collection-card"
                aria-label={`View the ${item.name} collection`}
              >
                {item.category === "video" ? (
                  <video
                    src={item.video}
                    autoPlay
                    muted
                    loop
                    playsInline
                    aria-label={item.name}
                  />
                ) : (
                  <img
                    src={item.image}
                    alt={`${item.name} Collection - Maya Wears`}
                    loading="lazy"
                  />
                )}
              </Link>
            </div>
          );
        })}
      </div>       
    </section>
  );
};

export default React.memo(Collection);
